import { render } from "./SelfCollections.vue?vue&type=template&id=5ce9caa7"
import script from "./SelfCollections.vue?vue&type=script&lang=js"
export * from "./SelfCollections.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__